
import rouble from "./rouble.svg"
import { approvalsData } from "./approvals.data";

import { isTerminal } from "../../../../constants";
import { unsetUserRequestAction } from "../../../../redux/actions/Requests/CurrentRequest/unsetUserRequest.action";
import RequestServices from "../../../../frontend.services/RequestServices/RequestServices";
import CurrentRequestCard from "../ModalAssets/CurrentRequestCard/CurrentRequestCard";
import { Modal } from "../../Modal/Modal";
import { getLocalTripDetailThunk } from "../../../../redux/actions/LocalTrips/thunk/LocalTrips.thunk.action";
import {
    getCurrentLeaderRequestThunkAction,
} from "../../../../redux/actions/Requests/LeaderRequests/thunk/getCurrentLeaderRequest.thunk.action";
import {
    getIndividualCoefficientCardThunkAction,
} from "../../../../redux/actions/Requests/RequestsFromLeader/IndividualCoefficients/getIndividualCoefficientCardThunkAction";

import { LeftArrow } from "../../../../assets/icons/LeftArrow";
import { RightArrow } from "../../../../assets/icons/RightArrow";

import CustomLoader from "../../CustomLoader/CustomLoader";

import ErrorModal from "../../Modal/ModalConditions/Profile/ErrorModal/ErrorModal";

import UserRequestCard from "../ModalAssets/UserRequestCard/UserRequestCard";

import { memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ClipLoader } from "react-spinners";
import ReactPaginate from "react-paginate";
import React from "react";
import moment from "moment";

isTerminal ? import("./ApprovalsTerminal.scss") : import("./Approvals.scss");

const Approvals = ({
    requests,
    currentRows,
    currentRowsHandler,
    rowsPerPage,
}) => {

    const dispatch = useDispatch();

    const [description, setDescription] = useState("");
    const [modalShownReferences, toggleModalShownReferences] = useState(false);
    const [itemOffset, setItemOffset] = useState(0);

    const endOffset = itemOffset + rowsPerPage;
    const currentItems = requests && requests.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(requests?.length / rowsPerPage);

    function clickHandlerReferences(uid, i, isFinanciallyResponsible, type, typeId) {
        toggleModalShownReferences(!modalShownReferences);
        if (typeId === 22) {
            dispatch(getIndividualCoefficientCardThunkAction(uid, { setDescription: setDescription }));
        } else if(type === "request:local-trip") {
            dispatch(getLocalTripDetailThunk(uid, { setDescription: setDescription }));
        } else {
            dispatch(getCurrentLeaderRequestThunkAction(uid, false, { setDescription: setDescription }, isFinanciallyResponsible));
        }
    }

    function closeHandlerReferences(e) {
        toggleModalShownReferences(false);
        dispatch(unsetUserRequestAction());
    }

    const handlePageClick = (event) => {
        const newOffset = (event.selected * rowsPerPage) % requests.length;
        setItemOffset(newOffset);
    };

    useEffect(() => {
        if (itemOffset < rowsPerPage) setItemOffset(0);
        setItemOffset(Math.floor(itemOffset / rowsPerPage) * rowsPerPage);
    }, [itemOffset, rowsPerPage]);

    return !requests
        ? <CustomLoader />
        : (<div>
            <div className="table-container ">
                <div className="table-container__legend ">
                    <div className="table-container__legend__color-item"></div>
                    <div>— Материально ответственное лицо
                </div>
                </div>
                <table className="leader-table">
                    <thead>
                        <tr className="leader-table__row">
                            {approvalsData &&
                                approvalsData.map((el) => {
                                    return (
                                        <th
                                            key={el.id}
                                            style={{ width: `${el.width}` }}
                                            className="leader-table__row__item"
                                        >
                                            {el.title}
                                            {
                                                el.icon
                                                    ? <img
                                                        src={el.icon}
                                                        alt="triangle"
                                                        className="header-triangle" />
                                                    : null}
                                        </th>
                                    );
                                })}
                        </tr>
                    </thead>
                    <tbody>
                        {currentItems &&
                            currentItems.map((el, i) => (
                                <tr
                                    onClick={() =>
                                        clickHandlerReferences(
                                            el.uid,
                                            i,
                                            el.isFinanciallyResponsible,
                                            el.entityType?.code,
                                            el.type,
                                        )
                                    }
                                    key={`${el.id}-${i}`}
                                    className={
                                        el.status !== 3
                                            ? el.expired && el.status === 3
                                                ? "row-request-leader-table expired"
                                                : "row-request-leader-table"
                                            : el.expired
                                                ? "row-request-leader-table-active expired"
                                                : "row-request-leader-table-active "
                                    }
                                >
                                    <td style={{ width: "98px" }}>
                                        {el.typeText}
                                    </td>
                                    <td style={{ width: "170px" }}>
                                        {el.leaveReasonId}
                                    </td>
                                    <td style={{ width: "170px" }}>
                                        {el.initiatorFullname}
                                    </td>
                                    <td style={{ width: "160px" }}>
                                        {moment(el.expireApprovalDate).format("DD.MM.YYYY")}
                                    </td>
                                    <td style={{ width: "147px" }}>
                                        {el.statusText}
                                    </td>
                                    <td style={{ width: "161px" }}>
                                        {el.employeeComment
                                            ? el.employeeComment.length > 15
                                                ? el.employeeComment.slice(
                                                    0,
                                                    15,
                                                ) + "..."
                                                : el.employeeComment
                                            : "..."}
                                    </td>
                                    <td
                                        // onClick={(e) => e.stopPropagation()}
                                        style={{ width: "134px", display: "flex", gap: "45px" }}
                                    >
                                        {moment(el.createDate).format("DD.MM.YYYY")}
                                        {el.isFinanciallyResponsible ? (
                                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                            // <div className={"isFinanciallyResponsible-legend"}></div>
                                           <div className="table-container__legend__color-item"></div>
                                        ) : (
                                            ""
                                        )}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
                {!requests.length
                    ? <div>

                    </div>
                    : <div className={isTerminal && "pagination-wrapper"}>
                        <div className="pagination-container">
                            <div className="pagination-container__rows">
                                <div
                                    onClick={() => currentRowsHandler(5)}
                                    className={
                                        rowsPerPage === 5
                                            ? "rowsPerPage-number-active"
                                            : "rowsPerPage-number-inactive"
                                    }
                                >
                                        5
                                </div>
                                <div
                                    onClick={() => currentRowsHandler(10)}
                                    className={
                                        rowsPerPage === 10
                                            ? "rowsPerPage-number-active"
                                            : "rowsPerPage-number-inactive"
                                    }
                                >
                                        10
                                </div>
                                <div
                                    onClick={() => currentRowsHandler(20)}
                                    className={
                                        rowsPerPage === 20
                                            ? "rowsPerPage-number-active"
                                            : "rowsPerPage-number-inactive"
                                    }
                                >
                                        20
                                </div>

                                <div
                                    onClick={() => currentRowsHandler(50)}
                                    className={
                                        rowsPerPage === 50
                                            ? "rowsPerPage-number-active"
                                            : "rowsPerPage-number-inactive"
                                    }
                                >
                                        50
                                </div>
                            </div>
                        </div>
                        <ReactPaginate
                            className={"pagination"}
                            breakLabel=".."
                            nextLabel={isTerminal ? <RightArrow /> : ">"}
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={3}
                            pageCount={pageCount}
                            previousLabel={isTerminal ? <LeftArrow /> : "<"}
                            renderOnZeroPageCount={null}
                            forcePage={Math.floor(itemOffset / rowsPerPage)}
                        />
                    </div>
                }
            </div>
            <Modal shown={modalShownReferences} close={closeHandlerReferences}>
                <UserRequestCard
                    isLeader={true}
                    setDescription={setDescription}
                    description={description}
                    userRequests={{items: requests}}
                    close={closeHandlerReferences}
                />


            </Modal>
        </div>
        );
};

export default memo(Approvals);
